import { SystemProps, SystemStyleObject } from '@chakra-ui/react';
import type { ColorMode } from '@allergan-data-labs/alle-elements-core';
import type { ButtonColorScheme, ButtonVariants } from './button';
import { getVariantStyles } from './button.theme';

export const getLabelButtonActiveStyles = (
  variant: ButtonVariants,
  colorScheme: ButtonColorScheme,
  colorMode: ColorMode
): Record<string, SystemStyleObject> => {
  const variantStyle = getVariantStyles(
    variant,
    colorScheme,
    colorMode
  ) as SystemProps;

  return {
    '&[data-active]': {
      background: variantStyle.bg as string,
      _hover: {
        backgroundColor: variantStyle._hover?.bg as string,
      },
    },
  };
};

export const getOverflowButtonActiveStyles = (
  variant: ButtonVariants,
  colorScheme: ButtonColorScheme,
  colorMode: ColorMode
): SystemStyleObject => {
  const styles = getLabelButtonActiveStyles(variant, colorScheme, colorMode);
  const variantStyles = { ...styles['&[data-active]'], boxShadow: 'none' };

  if (variant === 'ghost') {
    variantStyles.background = `${colorMode}.Container/Brand/Transparent interactive/Enable`;
    variantStyles.boxShadow = 'Elevation/1';
  }

  return {
    '&[data-active]': variantStyles,
  };
};

export const getButtonContentStyles = (gap = '8'): SystemStyleObject => {
  return {
    alignItems: 'center',
    justifyContent: 'space-between',
    gap,
  };
};
